module.exports = __webpack_public_path__ + "img/Calum Chambers.cf772d78.png";